import WebViewer from "./WebViewer";
import React from 'react'

export default function ImageGalleryViewer({estilo,webImagesArrays,textosWeb})
{
    return(
        <React.Fragment>
            {webImagesArrays.map((grupo, index) => (
                    <WebViewer
                        estilo = {estilo}
                        type = {'images'}
                        rotuloWeb={textosWeb[index]}
                        imagesList={grupo}
                         >
                    </WebViewer>
            ))}
        </React.Fragment>
    )
}